import {
    FETCH_CREATE_ANNOUNCEMENTS_REQUEST,
    FETCH_CREATE_ANNOUNCEMENTS_SUCCESS,
    FETCH_CREATE_ANNOUNCEMENTS_FAILURE,
} from '../../actions/announcement/create-announcement-action';

const initialState = {
    createdAnnouncement: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateAnnouncementReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_ANNOUNCEMENTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_ANNOUNCEMENTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdAnnouncement: { ...action.payload[0] },
            };
        case FETCH_CREATE_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateAnnouncementReducer;